import type { ReactNode } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

type DeltaKind = 'good' | 'bad' | 'neutral';

interface KpiCardProps {
  label: string;
  value: string | number;
  unit?: string;
  delta?: string;
  deltaKind?: DeltaKind;
  icon?: ReactNode;
  className?: string;
}

export const KpiCard = ({
  label,
  value,
  unit,
  delta,
  deltaKind = 'neutral',
  icon,
  className = '',
}: KpiCardProps) => {
  const deltaColors: Record<DeltaKind, string> = {
    good: 'text-[var(--color-good)]',
    bad: 'text-[var(--color-bad)]',
    neutral: 'text-[var(--color-ink-faint)]',
  };

  return (
    <div
      className={`rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] p-5 ${className}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-[var(--color-ink-faint)]">{label}</p>
          <p className="mt-1 text-2xl font-bold text-[var(--color-ink)]">
            {value}
            {unit && (
              <span className="ml-1 text-sm font-normal text-[var(--color-ink-soft)]">{unit}</span>
            )}
          </p>
        </div>
        {icon && (
          <div className="rounded-lg bg-[var(--color-accent-soft)] p-2 text-[var(--color-accent)]">
            {icon}
          </div>
        )}
      </div>
      {delta && (
        <div className={`mt-2 flex items-center gap-1 text-sm ${deltaColors[deltaKind]}`}>
          {deltaKind === 'good' && <TrendingUp className="h-4 w-4" />}
          {deltaKind === 'bad' && <TrendingDown className="h-4 w-4" />}
          <span>{delta}</span>
        </div>
      )}
    </div>
  );
};
